import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Grid from '@blocks/Grid'
import { notify } from '@helpers'
import { colors } from '@styles/vars'
import React from 'react'
import styled from "styled-components"
import { useVotingDashboardContext } from '../../../context'

export default function BestAuthorRadioInput(author: Admin.Resources.BestAuthor) {
    const { salon } = useSalonManagerContext()
    const { voting } = useVotingDashboardContext()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        salon.api.best(author.id)
        voting.setData(old => ({ ...old, best_author_id: author.id }))
        notify("Best author was updated.")
    }

    return (
        <Wrapper>
            <input type="radio" id={`best-author-${author.id}`} checked={author.id === voting.data.best_author_id} value={author.id} name="best_author" onChange={handleChange} />
            <Label htmlFor={`best-author-${author.id}`}>
                <Grid gap="10px">
                    <Grid gap="10px">
                        <Grid gap="3px">
                            <h4>{author.first_name} {author.last_name}</h4>
                            <p>{author.acceptances_count} acceptances</p>
                        </Grid>
                        {author.participations.length > 0 && (
                            <Grid gap="5px">
                                {author.participations.map(item => <small>{item.award}</small>)}
                            </Grid>
                        )}
                    </Grid>
                    <hr />
                    <small>{author.id === voting.data.best_author_id ? "Selected" : "Select"}</small>
                </Grid>
            </Label>
        </Wrapper>
    )
}

const Label = styled.label`
    display: block;
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    border: 1px solid ${colors.border};
    cursor: pointer;

    hr {
        background: ${colors.border};
        margin: 0;
    }
`

const Wrapper = styled.div`
    input {
        position: absolute;
        z-index: -1;
        opacity: 0;
    }

    input:checked + ${Label} {
        background: ${colors.black};
        
        h4 {
            color: ${colors.white};
        }

        p, small {
            color: ${colors.white};
            opacity: .8;
        }

        hr {
            background: hsla(0, 0%, 100%, 0.2);
        }
    }
`